export const environment = {
	production: true,
	// base_url: "http://rccs.test",
  	// main_url: "https://rccs.edugh.net/",
	base_url: "https://dwecapi.edugh.net",
  	main_url: "https://dwec.edugh.net/",
	// base_url: "https://angelapi.edugh.net/",
  	// main_url: "https://angelstaging.edugh.net/",
	salt: 'edu_key_salt'
};
